import { HotKeyBox } from '@modules/common/components/HotKeyIcons/HotKeyBox';
import { OptionAltHotkeySymbol } from '@modules/common/components/OptionAltHotkeySymbol';
import { useCopyToClipboard, useHotkey } from '@modules/common/hooks';
import { LinkRounded } from '@mui/icons-material';
import { alpha, Button, IconButton, Stack, Typography } from '@mui/material';
import { useGetUser } from 'v2/core/services/user';
import { trackFeedbackEvents } from '../../utils';

interface CopyFeedbackURLToClipboardProps {
  message?: string;
  buttonText?: string;
  feedbackID: string;
  isDetailView: boolean;
}

const CopyFeedbackURLToClipboard = ({
  message = 'Copied to clipboard!',
  buttonText = 'Copy Feedback Link',
  feedbackID,
  isDetailView,
}: CopyFeedbackURLToClipboardProps) => {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const copyTextToClipboard = useCopyToClipboard();

  const feedbackPageUrl = `${window.location.origin}/${tenantSlug}/record/${feedbackID}`;

  const onClick = () => {
    copyTextToClipboard(feedbackPageUrl, message);
    trackFeedbackEvents({
      eventName: 'Feedback Link Copied',
      feedbackID,
    });
  };

  useHotkey({
    hotkey: 'Alt+KeyL',
    onHotkey: onClick,
    isHotKeyDisabled: !isDetailView,
    actionTitle: 'Copy Feedback Link',
  });

  return (
    <>
      {!isDetailView ? (
        <IconButton color="primary" onClick={onClick}>
          <LinkRounded />
        </IconButton>
      ) : (
        <Button
          onClick={onClick}
          variant="outlined"
          startIcon={<LinkRounded />}
          endIcon={
            <HotKeyBox
              hotkeyDisplay={
                <Stack direction="row" spacing={0.5} alignItems="center">
                  <OptionAltHotkeySymbol />
                  <Typography
                    fontSize="body2"
                    component="span"
                    fontWeight={500}
                  >
                    L
                  </Typography>
                </Stack>
              }
              backgroundColor={(theme) =>
                alpha(theme.palette.primary.main, 0.15)
              }
            />
          }
        >
          {buttonText}
        </Button>
      )}
    </>
  );
};

export default CopyFeedbackURLToClipboard;
